import React from 'react';
import { inicialesDe, colorDe } from '../utils/grupo';

interface Props {
  nombre?: string | null;
  /** Lado del cuadrado en píxeles. */
  tamano?: number;
}

/**
 * El distintivo del grupo: sus iniciales sobre un color propio.
 *
 * Va junto al nombre para reconocerlo sin leer, que es lo que hace falta
 * cuando alguien trabaja con dos grupos. Sale del nombre, así que funciona
 * desde el primer día sin que nadie suba nada.
 */
const InicialGrupo: React.FC<Props> = ({ nombre, tamano = 34 }) => (
  <span
    aria-hidden
    title={nombre || undefined}
    style={{
      width: tamano,
      height: tamano,
      flexShrink: 0,
      background: colorDe(nombre),
      color: '#fff',
      borderRadius: tamano * 0.28,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 800,
      fontSize: tamano * 0.42,
      letterSpacing: '.02em',
      lineHeight: 1
    }}
  >
    {inicialesDe(nombre)}
  </span>
);

export default InicialGrupo;
